import React from 'react'
import { TableColumn } from '../../../../../components/ModularDataTable'
import { Input } from '../../../../../components/Input/Input'
import { i18n } from '../../../../../translate/i18n'
import { VariationType } from '../types'

type ColumnsFactoryParams = {
  disableFieldsTotvs: boolean
  changeVariation: (item: VariationType, field: string) => void
  switchStatus: (params: { endpoint: string; Id: number; status: boolean }) => void
  setVariations: React.Dispatch<React.SetStateAction<VariationType[]>>
}

export function createColumns({
  disableFieldsTotvs,
  changeVariation,
  switchStatus,
  setVariations,
}: ColumnsFactoryParams): TableColumn[] {
  return [
    { key: i18n.t(`smart_order.sku`), value: 'sku', type: 'text', sortable: true },
    { key: i18n.t(`smart_order.name`), value: 'name', type: 'text', sortable: true },
    { key: i18n.t(`smart_order.referenceCode`), value: 'code', type: 'text', sortable: true },
    {
      key: i18n.t(`smart_order.specification`),
      value: 'specification',
      type: 'custom',
      sortable: true, 
      render: (value: any) => <div dangerouslySetInnerHTML={{ __html: value }} />,
    },
    createMoneyColumn({
      key: i18n.t(`smart_order.price`),
      field: 'price',
      disableFieldsTotvs,
      changeVariation,
    }),
    createMoneyColumn({
      key: i18n.t(`smart_order.promotional_price`),
      field: 'promotionalPrice',
      disableFieldsTotvs,
      changeVariation,
    }),
    {
      key: i18n.t(`smart_order.inventory`),
      value: 'inventory',
      type: 'custom',
      sortable: true, 
      render: (value: any, row: VariationType) => (

        <Input
          inputAttr={{ type: 'number' }}
          disabled={disableFieldsTotvs}
          change={(val: string) => {
            row.inventory = Number(val)
            setVariations((prev: VariationType[]) =>
              prev.map((v) => (v.id === row.id ? { ...v, inventory: Number(val) } : v))
            )
          }}
          blur={() => changeVariation(row, 'inventory')}
          value={value}
        />

      ),
    },
    {
      key: 'Status',
      value: 'status',
      type: 'custom',
      align: 'center',
      render: (_value: any, row: VariationType) => (
        <div className='mt-5'>
          <Input
            value={row.status}
            checked={row.status}
            change={(val: boolean) => {
              switchStatus({ endpoint: 'variations', Id: row.id, status: val })
            }}
            inputAttr={{ type: 'checkbox' }}
            checkSwift={true}
            disabled={disableFieldsTotvs}
          />
        </div>
      ),
    },
    {
      key: 'Imagem',
      value: 'variationImg',
      type: 'custom',
      render: (value: any) => {
        const valueStr = value ? String(value).toLowerCase().trim() : ''
        const hasImage =
          valueStr.startsWith('http://') ||
          valueStr.startsWith('https://') ||
          valueStr.startsWith('s3://')

        if (hasImage) {
          return (
            <span className='badge badge-success mt-5'>
              <i className='fas fa-image me-1'></i>Possui
            </span>
          )
        }
        return (
          <span className='badge badge-secondary mt-5'>
            <i className='fas fa-image-slash me-1'></i>Sem imagem
          </span>
        )
      },
    },
  ]
}

function createMoneyColumn({
  key,
  field,
  disableFieldsTotvs,
  changeVariation,
}: {
  key: string
  field: string
  disableFieldsTotvs: boolean
  changeVariation: (item: VariationType, field: string) => void
}): TableColumn {
  return {
    key,
    value: field,
    type: 'custom',
    visible: disableFieldsTotvs,
    render: (value: any, row: VariationType) => (
      <Input
        inputAttr={{ type: 'money' }}
        disabled={disableFieldsTotvs}
        currency='BRL'
        locale='pt-BR'
        change={(val: string) => {
          ; (row as any)[field] = Number(val)
        }}
        blur={() => changeVariation(row, field)}
        value={(row as any)[field]}
      />
    ),
  }
}
